'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _extends2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _Element2 = require('./Element');

var _Element3 = _interopRequireDefault(_Element2);

var _set = require('./utils/set');

var _set2 = _interopRequireDefault(_set);

var _traverse = require('./utils/traverse');

var _traverse2 = _interopRequireDefault(_traverse);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _Textarea = require('./Textarea');

var _Textarea2 = _interopRequireDefault(_Textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEmpty(value) {
  return typeof value === 'undefined' || value === null || value === '';
}

var Fieldset = (_temp = _class = function (_Element) {
  (0, _inherits3.default)(Fieldset, _Element);

  function Fieldset() {
    (0, _classCallCheck3.default)(this, Fieldset);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, _Element.call.apply(_Element, [this].concat(args)));

    _this.registeredChildren = [];
    return _this;
  }

  Fieldset.prototype.getTotals = function getTotals() {
    var totals = [];
    if (typeof this.props.total !== 'undefined') {
      totals.push(this.props.total);
    }

    var parent = this.getParent();
    if (!parent) {
      return totals;
    }

    var parentTotals = parent.getTotals();
    return [].concat(totals, parentTotals);
  };

  Fieldset.prototype.getIndexes = function getIndexes() {
    var indexes = [];
    if (typeof this.props.index !== 'undefined') {
      indexes.push(this.props.index);
    }

    var parent = this.getParent();
    if (!parent) {
      return indexes;
    }

    var parentIndexes = parent.getIndexes();
    return [].concat(indexes, parentIndexes);
  };

  Fieldset.prototype.setValue = function setValue(value, component, notifyChildren) {
    _Element.prototype.setValue.call(this, value, component, notifyChildren);

    if (notifyChildren) {
      this.notifyChildren();
    }
  };

  Fieldset.prototype.originalValueChanged = function originalValueChanged() {
    _Element.prototype.originalValueChanged.call(this);
    this.notifyChildren();
  };

  Fieldset.prototype.notifyChildren = function notifyChildren() {
    var registeredChildren = this.registeredChildren;

    registeredChildren.forEach(function (child) {
      return child.originalValueChanged();
    });
  };

  Fieldset.prototype.registerChild = function registerChild(child, name) {
    if (name && name[0] === '.') {
      var parent = this.getParent();
      parent.registerChild(child, name.substr(1));
      return;
    }

    this.registeredChildren.push(child);
  };

  Fieldset.prototype.unregisterChild = function unregisterChild(child, name) {
    if (name && name[0] === '.') {
      var parent = this.getParent();
      parent.unregisterChild(child, name.substr(1));
      return;
    }

    var pos = this.registeredChildren.indexOf(child);
    if (pos !== -1) {
      this.registeredChildren.splice(pos, 1);
    }
  };

  Fieldset.prototype.getChildContext = function getChildContext() {
    return {
      fieldset: this
    };
  };

  Fieldset.prototype.remove = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(index) {
      var parent, value;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof index === 'undefined')) {
                _context.next = 3;
                break;
              }

              parent = this.getParent();
              return _context.abrupt('return', parent.remove(this.getCurrentIndex()));

            case 3:
              value = this.getValue();

              if (!(!Array.isArray(value) || index < 0 || value.length <= index)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return', undefined);

            case 6:

              this.setValue([].concat(value.slice(0, index), value.slice(index + 1)));

              return _context.abrupt('return', index);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function remove(_x) {
      return _ref.apply(this, arguments);
    }

    return remove;
  }();

  Fieldset.prototype.up = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(index) {
      var parent, value;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof index === 'undefined')) {
                _context2.next = 3;
                break;
              }

              parent = this.getParent();
              return _context2.abrupt('return', parent.up(this.getCurrentIndex()));

            case 3:
              value = this.getValue();

              if (!(!Array.isArray(value) || index <= 0 || value.length <= index)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return', undefined);

            case 6:

              this.setValue([].concat(value.slice(0, index - 1), [value[index], value[index - 1]], value.slice(index + 1)));

              return _context2.abrupt('return', index);

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function up(_x2) {
      return _ref2.apply(this, arguments);
    }

    return up;
  }();

  Fieldset.prototype.getCurrentIndex = function getCurrentIndex() {
    var name = this.props.name;

    if (name === undefined) {
      throw new Error('This is not an array');
    }

    var indexNumber = Number(name);
    if (indexNumber.toString() !== name.toString() || !(0, _isNumber2.default)(indexNumber)) {
      throw new Error('Index ' + indexNumber + ' is not a number');
    }

    return indexNumber;
  };

  Fieldset.prototype.down = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(index) {
      var parent, retVar;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(typeof index === 'undefined')) {
                _context3.next = 3;
                break;
              }

              parent = this.getParent();
              return _context3.abrupt('return', parent.down(this.getCurrentIndex()));

            case 3:
              retVar = this.up(index + 1);
              return _context3.abrupt('return', typeof retVar === 'undefined' ? retVar : index);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function down(_x3) {
      return _ref3.apply(this, arguments);
    }

    return down;
  }();

  // return current or parent fieldset


  Fieldset.prototype.resolveByPath = function resolveByPath(path, callback) {
    if (path[0] === '.') {
      var subPath = path.substr(1);
      if (isEmpty(subPath)) {
        return callback(null, this, subPath);
      }

      var parent = this.getParent();
      return parent.resolveByPath(subPath, callback);
    }

    return callback(null, this, path);
  };

  Fieldset.prototype.getChildValue = function getChildValue(path) {
    if (isEmpty(path)) {
      return this.getValue();
    }

    return this.resolveByPath(path, function (err, current, subPath) {
      if (err) {
        throw err;
      }

      var value = current.getValue();
      if (isEmpty(subPath)) {
        return value;
      }

      return (0, _get2.default)(value, subPath);
    });
  };

  Fieldset.prototype.setChildValue = function setChildValue(path, value, component) {
    this.resolveByPath(path, function (err, current, subPath) {
      if (err) {
        throw err;
      }

      var newValue = value;
      if (!isEmpty(subPath)) {
        var currentValue = current.getValue();
        newValue = (0, _set2.default)(currentValue, subPath, value);
      }

      current.setValue(newValue, component);

      var onChange = current.props.onChange;

      if (onChange) {
        onChange(newValue, component);
      }
    });
  };

  Fieldset.prototype.buildPath = function buildPath(path) {
    return this.resolveByPath(path, function (err, current, subPath) {
      if (err) {
        throw err;
      }

      var currentPath = current.getPath();
      if (isEmpty(subPath)) {
        return currentPath;
      }

      return currentPath ? currentPath + '.' + subPath : subPath;
    });
  };

  Fieldset.prototype.disableSmartUpdate = function disableSmartUpdate(name) {
    if (!name || name[0] !== '.' || name === '.') {
      return;
    }

    this.smartUpdate = false;

    var parent = this.getParent();
    if (!parent) {
      return;
    }

    parent.disableSmartUpdate(name.substr(1));
  };

  Fieldset.prototype.replaceChildren = function replaceChildren(children) {
    var skipReplace = this.getForm().props.skipReplace;

    if (skipReplace) {
      return children;
    }

    return (0, _traverse2.default)(children, null, function (child) {
      if (child.props && child.props.skipReplace) {
        return undefined;
      }

      var childChildren = child.props && child.props.children || child.children;

      if (child.type === 'input') {
        return _react2.default.createElement(
          _Input2.default,
          child.props,
          childChildren
        );
      } else if (child.type === 'select') {
        return _react2.default.createElement(
          _Select2.default,
          child.props,
          childChildren
        );
      } else if (child.type === 'textarea') {
        return _react2.default.createElement(
          _Textarea2.default,
          child.props,
          childChildren
        );
      } else if (child.type === 'fieldset' && child.props.name !== undefined) {
        return _react2.default.createElement(
          Fieldset,
          child.props,
          childChildren
        );
      } else if (child.type === 'tbody' && child.props.name !== undefined) {
        return _react2.default.createElement(
          Fieldset,
          (0, _extends4.default)({}, child.props, { tagName: 'tbody' }),
          childChildren
        );
      }

      return undefined;
    });
  };

  Fieldset.prototype.processChildren = function processChildren(children) {
    var value = this.getValue();
    var render = this.props.render;


    if (typeof render === 'function') {
      return this.replaceChildren(render({ value: value }));
    }

    var path = this.getPath();
    var skipMap = this.props.skipMap;

    if (Array.isArray(value) && !skipMap) {
      var childrenOnly = this.props.tagName === 'tbody';

      return value.map(function (item, index) {
        var uniqueKey = path + '.' + index;

        return _react2.default.createElement(
          Fieldset,
          {
            name: index,
            key: uniqueKey,
            total: value.length,
            childrenOnly: childrenOnly
          },
          children
        );
      });
    }

    return this.replaceChildren(children);
  };

  Fieldset.prototype.render = function render() {
    var children = this.processChildren(this.props.children);
    var _props = this.props,
        _props$tagName = _props.tagName,
        tagName = _props$tagName === undefined ? 'fieldset' : _props$tagName,
        className = _props.className,
        style = _props.style,
        childrenOnly = _props.childrenOnly;


    if (childrenOnly) {
      return children;
    }

    return (0, _react.createElement)(tagName, {
      className: className,
      style: style,
      'data-path': this.getPath()
    }, children);
  };

  return Fieldset;
}(_Element3.default), _class.propTypes = (0, _extends4.default)({}, _Element3.default.propTypes, (_extends2 = {
  onChange: _propTypes2.default.func,
  index: _propTypes2.default.number,
  total: _propTypes2.default.number,
  children: _propTypes2.default.node,
  tagName: _propTypes2.default.string,
  childrenOnly: _propTypes2.default.bool
}, _extends2['children'] = _propTypes2.default.node, _extends2.sameChildren = _propTypes2.default.bool, _extends2)), _class.childContextTypes = {
  fieldset: _propTypes2.default.object.isRequired
}, _class.contextTypes = {
  fieldset: _propTypes2.default.object
}, _temp);
exports.default = Fieldset;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Fieldset.js
 ** module id = 355
 ** module chunks = 0
 **/